import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import ReactDOM from 'react-dom/client';
import App from './App';
import Navbar from './navbar';
import reportWebVitals from './reportWebVitals';
import Sidebar from './sidebar';
import Footer from './footer';
import $ from 'jquery';


if (process.env.NODE_ENV === "production")
  console.log = function no_console() { };

// ปิดแจ้งเตือน warning ของ React dev (Warning: validateDOMNesting / non-boolean attribute ฯลฯ)
const _origError = console.error;
console.error = function (...args) {
  if (typeof args[0] === "string" && args[0].indexOf("Warning:") === 0) return;
  _origError.apply(console, args);
};
const _origWarn = console.warn;
console.warn = function (...args) {
  if (typeof args[0] === "string" && args[0].indexOf("Warning:") === 0) return;
  _origWarn.apply(console, args);
};

// ซ่อนรูปที่โหลดไม่ขึ้น (โดเมนตาย/ถูกบล็อก) ไม่ให้โชว์ไอคอนรูปแตก — prod ที่รูปโหลดได้จะไม่ถูกซ่อน
if (typeof document !== "undefined") {
  document.addEventListener("error", function (e) {
    var el = e.target;
    if (el && el.tagName === "IMG" && el.getAttribute("data-bimg") !== "1" && el.src && el.src.indexOf("data:") !== 0) {
      el.setAttribute("data-bimg", "1");
      el.style.visibility = "hidden";
    }
  }, true);
}

const sidebar = ReactDOM.createRoot(document.getElementById('sidebar'));
sidebar.render(
  <>
    <Sidebar />
  </>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
      <App />
  </>
);

const navbar = ReactDOM.createRoot(document.getElementById('navbar'));
navbar.render(
  <>
      <Navbar />
  </>
);

const footer = ReactDOM.createRoot(document.getElementById('footer'));
footer.render(
  <>
    <Footer />
  </>
);



reportWebVitals();
